export enum AdmissionGroupRequestEvent {
  CREATED = 'ADMISSION_GROUP_REQUEST_CREATED',
}
